/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs */

const en__field__enum_studyprograms_study_educational_sciences25 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educational Sciences`)
};

const de__field__enum_studyprograms_study_educational_sciences25 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erziehungswissenschaft`)
};

/**
* | output |
* | --- |
* | "Educational Sciences" |
*
* @param {_Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_educational_sciences25 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Educational_Sciences25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_educational_sciences25(inputs)
	return de__field__enum_studyprograms_study_educational_sciences25(inputs)
});
export { _field__enum_studyprograms_study_educational_sciences25 as "_field__enum_studyPrograms_STUDY_EDUCATIONAL_SCIENCES" }